import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FooterLabel_EN } from 'src/app/models/labels/footerLabel_EN';
import { FooterLabel_HN } from 'src/app/models/labels/footerLabel_HN';
import { BorrowerRenderingService } from 'src/app/services/borrower/borrower-rendering.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {
  label: FooterLabel_EN;
  hn_en: string;

  constructor(public dialogRef: MatDialogRef<TermsAndConditionsComponent>,
    public borrowerRenderingService: BorrowerRenderingService) { }

  ngOnInit() {
    if (this.borrowerRenderingService.language) {
      if (this.borrowerRenderingService.language === "ENGLISH") {
        this.label = new FooterLabel_EN();
        this.hn_en = "EN";
      } else if (this.borrowerRenderingService.language === "HINDI") {
        this.label = new FooterLabel_HN();
        this.hn_en = "HN";
      }
    } else {
      this.label = new FooterLabel_EN();
      this.hn_en = "EN";
    }

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
